import React from "react";
import Textbox from "../../../components/Textbox";
import CheckBox from "../../../components/Checkbox/Checkbox";

const Step1 = (props: any) => {
  const { values, handleChange, errors, touched, check, shopId } = props;
  return (
    <div>
      <div className="subtitle clearfix">
        <h2 className="title2">Shop Details</h2>
      </div>
      <div className="row">
        <div className="col-md-6">
          <Textbox
            name="name"
            placeholder="Enter your Details here"
            value={values.name}
            onChange={handleChange}
            label="Name Of Owner"
            errorMessage={touched.name && errors.name}
          />
        </div>
        <div className="col-md-6">
          <Textbox
            name="phone"
            type="number"
            placeholder="Enter your Phone here"
            value={values.phone}
            onChange={handleChange}
            label="Phone"
            maxLength={10}
            errorMessage={touched.phone && errors.phone}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-md-6">
          <Textbox
            name="email"
            placeholder="Enter your Email here"
            value={values.email}
            onChange={handleChange}
            label="Email"
            errorMessage={touched.email && errors.email}
          />
        </div>
        <div className="col-md-6">
          <Textbox
            name="username"
            placeholder="Enter your Username here"
            value={values.username}
            onChange={handleChange}
            label="Username"
            autoComplete="new-password"
            errorMessage={touched.username && errors.username}
            // disabled={shopId > 0 ? true : false}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-md-6">
          {shopId > 0 ? null : (
            <Textbox
              name="password"
              placeholder="Enter your Password here"
              value={values.password}
              type="password"
              autoComplete="new-password"
              onChange={handleChange}
              label="Password"
              errorMessage={touched.password && errors.password}
            />
          )}
        </div>
        <div className={shopId > 0 ? "col-md-12" : "col-md-6"}>
          <Textbox
            name="number_of_order"
            type="number"
            placeholder="Enter no. of Orders"
            value={values.number_of_order}
            onChange={handleChange}
            label="Number of Orders"
            maxLength={10}
            errorMessage={touched.number_of_order && errors.number_of_order}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-md-3">
          <Textbox
            name="number_of_food"
            type="number"
            placeholder="Enter no. of Foods"
            value={values.number_of_food}
            onChange={handleChange}
            label="Number of Foods"
            maxLength={10}
            errorMessage={touched.number_of_food && errors.number_of_food}
          />
        </div>
        <div className="col-md-3">
          <Textbox
            name="number_of_category"
            type="number"
            placeholder="Enter no. of Categories"
            value={values.number_of_category}
            onChange={handleChange}
            label="Number of Categories"
            maxLength={10}
            errorMessage={
              touched.number_of_category && errors.number_of_category
            }
          />
        </div>
        <div className="col-md-3">
          <Textbox
            name="number_of_table"
            type="number"
            placeholder="Enter no. of Tables"
            value={values.number_of_table}
            onChange={handleChange}
            label="Number of Tables"
            maxLength={10}
            errorMessage={touched.number_of_table && errors.number_of_table}
          />
        </div>
        <div className="col-md-3">
          <Textbox
            name="trial_day"
            type="number"
            placeholder="Enter no. of Trial Days"
            value={values.trial_day}
            onChange={handleChange}
            label="Number of Trail Days"
            maxLength={10}
            errorMessage={touched.trial_day && errors.trial_day}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-md-6 mt-4 pl-4">
          <CheckBox
            name="is_active"
            label="Is Active?"
            onChange={handleChange}
            checked={values.is_active}
          />
        </div>
        <div className="col-md-6 mt-4">
          <CheckBox
            name="is_trial"
            label="Is Trial?"
            onChange={handleChange}
            checked={values.is_trial}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-md-6 mt-4 pl-4">
          <CheckBox
            name="toggle"
            label="Want to update Password?"
            onChange={handleChange}
            checked={values.toggle}
          />
        </div>
        <div className="col-md-6 mt-4">
          <CheckBox
            name="is_franchise"
            label="Is this is franchise?"
            onChange={handleChange}
            checked={values.is_franchise}
          />
        </div>
        <div className="col-md-6 mt-4">
          {values.toggle && (
            <Textbox
              name="newpassword"
              placeholder="Enter your Password here"
              value={values.newpassword}
              type="password"
              autoComplete="new-password"
              onChange={handleChange}
              label="Password"
              errorMessage={touched.newpassword && errors.newpassword}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default Step1;
